module.exports = __webpack_public_path__ + "img/spotmarkt-KUECHE.png";